import { render, staticRenderFns } from "./EventFieldPage.vue?vue&type=template&id=285ba9d7"
import script from "./EventFieldPage.vue?vue&type=script&lang=js"
export * from "./EventFieldPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports